<button
  class="gradient-btn"
  nz-button
  [nzSize]="'large'"
  [nzBlock]="fullSize"
  [nzLoading]="inspectionLoading"
  (click)="openWatchRequestModal()"
>
  {{ 'WATCH_REQUEST.TITLE' | translate }}
</button>
